// uses ./sideloadConfiguration.less

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import {
    reloadAppDefinition,
    reuploadSideloadedApp,
    closeSideloadedAppConfigurationModal,
    removeSideloadedApp,
    showConfirmationModal,
} from './sideloadConfigurationActionCreators';
import ConfirmationModal from '../common/ConfirmationModal';
import UploadSection from '../sideload/UploadSection';
import ErrorsSection from '../sideload/ErrorsSection';
import DeleteSection from '../sideload/DeleteSection';

import { resetFilters } from '../appsList/appsListFilters/appsListFiltersActionCreators';
import { withRouter } from '../../withRouter';

const SideloadConfiguration = ({
    appId,
    history,
    name,
    appDefinitionFile,
    dispatchCloseSideloadedAppConfigurationModal,
    isAppDefinitionLoaded,
    isAppDefinitionValid,
    isConfigurationVisible,
    showConfirmation,
    dispatchShowConfirmationModal,
    dispatchReloadAppDefinition,
    dispatchRemoveSideloadedApp,
    dispatchReuploadSideloadedApp,
    dispatchResetFilters,
    validationErrorDownload,
    validationErrorMessage,
    validationErrorDetails,
}) => {
    if (!isConfigurationVisible) {
        return null;
    }

    const handleFileReloadHandler = (event) => {
        dispatchReloadAppDefinition({
            appDefinitionFile: event.target.files[0],
        });
    };
    const handleRemoveSideloadedAppHandler = () => {
        dispatchRemoveSideloadedApp({
            appId,
        })
            .then(() => {
                history.push('/apps');

                return dispatchResetFilters();
            })
            .catch((err) => {
                if (err.statusCode === 404) {
                    // app doesn't exist
                    history.push('/apps');
                }
            });
    };
    const handleReuploadSideloadedAppHandler = () => {
        dispatchReuploadSideloadedApp({
            appId,
            sideloadedAppDefinition: appDefinitionFile,
        }).then(() => {
            history.push(`/apps/${appId}`);
        });
    };

    const sideloadedConfigurationModal = (
        <ConfirmationModal
            className="sideloaded-modal"
            closeHandler={dispatchCloseSideloadedAppConfigurationModal}
            cancelLabel="Cancel"
            title={`${name} configuration`}
            confirmHandler={handleReuploadSideloadedAppHandler}
            confirmLabel="Confirm"
            isDisabled={!isAppDefinitionLoaded || !isAppDefinitionValid}
        >
            <UploadSection
                isAppDefinitionLoaded={isAppDefinitionLoaded}
                appDefinitionFile={appDefinitionFile}
                onFileLoadHandler={handleFileReloadHandler}
            />
            <ErrorsSection
                isAppDefinitionValid={isAppDefinitionValid}
                validationErrorMessage={validationErrorMessage}
                validationErrorDownload={validationErrorDownload}
                validationErrorDetails={validationErrorDetails}
            />
            <div className="sideloaded-section-divider" />
            <DeleteSection name={name} onClickDeleteBtn={dispatchShowConfirmationModal} />
        </ConfirmationModal>
    );

    const sideloadedAppRemoveConfirmationModal = (
        <ConfirmationModal
            className="sideloaded-modal sideloaded-modal-remove-confirmation"
            closeHandler={dispatchCloseSideloadedAppConfigurationModal}
            cancelLabel="Cancel"
            title={`Delete ${name}`}
            confirmHandler={handleRemoveSideloadedAppHandler}
            confirmLabel="Delete"
        >
            <p>This action cannot be undone. I understand the consequences of removing this app from users accounts.</p>
        </ConfirmationModal>
    );

    return showConfirmation ? sideloadedAppRemoveConfirmationModal : sideloadedConfigurationModal;
};

SideloadConfiguration.propTypes = {
    appId: PropTypes.string,
    name: PropTypes.string,
    appDefinitionFile: PropTypes.object,
    dispatchCloseSideloadedAppConfigurationModal: PropTypes.func.isRequired,
    isAppDefinitionLoaded: PropTypes.bool.isRequired,
    isAppDefinitionValid: PropTypes.bool.isRequired,
    showConfirmation: PropTypes.bool.isRequired,
    validationErrorDownload: PropTypes.bool.isRequired,
    validationErrorMessage: PropTypes.string,
    validationErrorDetails: PropTypes.string,
};

const mapDispatchToProps = {
    dispatchCloseSideloadedAppConfigurationModal: closeSideloadedAppConfigurationModal,
    dispatchReloadAppDefinition: reloadAppDefinition,
    dispatchRemoveSideloadedApp: removeSideloadedApp,
    dispatchReuploadSideloadedApp: reuploadSideloadedApp,
    dispatchShowConfirmationModal: showConfirmationModal,
    dispatchResetFilters: resetFilters,
};

export default withRouter(connect((state) => state.sideload, mapDispatchToProps)(SideloadConfiguration));
